import { Controller } from "react-hook-form";
import { DatePicker } from "@onengine/component-library";
import { fromCalendarDate, toCalendarDate } from "@/utils/calendarDate";
import type { ControlledFieldProps } from "./types";

export function ControlledDatePicker({
  name,
  control,
  error,
  clearErrors,
  placeholder,
  isDateTime,
}: ControlledFieldProps & { placeholder?: string; isDateTime?: boolean }) {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field }) => (
        <DatePicker
          value={
            field.value
              ? isDateTime
                ? new Date(field.value)
                : fromCalendarDate(field.value)
              : null
          }
          onChange={(d) => {
            field.onChange(d ? (isDateTime ? new Date(d).toISOString() : toCalendarDate(d)) : "");
            clearErrors(name);
          }}
          valueFormat="MM/DD/YYYY"
          placeholder={placeholder}
          error={error}
        />
      )}
    />
  );
}
